import { useState, useRef, useCallback, useEffect } from 'react';
import { clearSession } from '../utils/auth';

const IDLE_TIMEOUT = 7 * 60 * 1000;

const useIdleLogout = () => {
  const idleTimer = useRef(null);
  const tickTimer = useRef(null);
  const [countdown, setCountdown] = useState(null);

  const logout = useCallback(() => {
    clearSession();
    window.location.href = '/admin';
  }, []);

  const reset = useCallback(() => {
    setCountdown(null);
    clearTimeout(idleTimer.current);
    clearInterval(tickTimer.current);
    idleTimer.current = setTimeout(() => {
      let sec = 60;
      setCountdown(sec);
      tickTimer.current = setInterval(() => {
        sec -= 1;
        if (sec <= 0) { clearInterval(tickTimer.current); logout(); }
        else setCountdown(sec);
      }, 1000);
    }, IDLE_TIMEOUT - 60000);
  }, [logout]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      clearTimeout(idleTimer.current);
      clearInterval(tickTimer.current);
      events.forEach(e => window.removeEventListener(e, reset));
    };
  }, [reset]);

  return countdown;
};

export default useIdleLogout;
